export var ChatModel;
(function (ChatModel) {
    ChatModel["GPT_4_1"] = "gpt-4.1-2025-04-14";
    ChatModel["GPT_4_1_NANO"] = "gpt-4.1-nano-2025-04-14";
    ChatModel["GPT_5_6_TERRA"] = "gpt-5.6-terra";
    ChatModel["GPT_5_6_LUNA"] = "gpt-5.6-luna";
})(ChatModel || (ChatModel = {}));
